import { sdkRequest } from '@eventbrite/http';
import * as Sentry from '@sentry/browser';
import { useQuery } from '@tanstack/react-query';
import { RegionDTO } from './types';

type RegionsResponse = {
    regions: RegionDTO[];
};

export const useRegions = () => {
    return useQuery({
        queryKey: ['regions'],
        queryFn: () => fetchRegions(),
    });
};

const fetchRegions = (): Promise<RegionDTO[]> =>
    sdkRequest(`/api/v3/system/regions/`)
        .then(({ regions }: RegionsResponse) => regions)
        .catch((error: Error) => {
            Sentry.captureException(error, {
                tags: {
                    endpoint: '/api/v3/system/regions/',
                },
                extra: {
                    message: 'Error fetching regions',
                },
            });

            throw error;
        });
